import { LoadingTrackCard } from '../TrackCard';
import styles from './LoadingActivitiesList.module.scss';

const LoadingActivitesList = () => (
  <div className={styles.activitiesLoading}>
    {new Array(6).fill(0).map((_, i) => (
      <LoadingTrackCard key={i} />
    ))}
  </div>
);

export default LoadingActivitesList;
